import { useQuery } from '@tanstack/react-query';

import { backendApis } from '@/backendApis';
import { userStore } from '@/stores/user.store';

// A watcher routine starts with its agent's first card after the list opens, so it refreshes while open
const WATCHER_REFETCH_MS = 60_000;

/** The signed-in user's card watcher routines, one per proactive agent, for internal users */
export const useCardWatcherRoutinesQuery = () =>
  useQuery({
    queryKey: ['card-watcher-routines'],
    queryFn: () => backendApis.cardWatchers.routines(),
    enabled: userStore.isInternalUser,
    refetchInterval: WATCHER_REFETCH_MS,
  });
